function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\uD83C\\uDF6A",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "index-desktop-copy-7",
  transform: "translate(-1117.000000, -96.000000)",
  fill: "#000000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Shape",
  transform: "translate(1117.000000, 96.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20,22.5119048 C20,23.1657966 19.4755355,23.702381 18.8277727,23.702381 L1.17222729,23.702381 C0.527623176,23.702381 0,23.1675283 0,22.5119048 C0,16.9233091 4.47715253,12.3928571 10,12.3928571 C15.5228475,12.3928571 20,16.9233091 20,22.5119048 Z M10,13.5833333 C5.12689929,13.5833333 1.17647059,17.580791 1.17647059,22.5119048 C1.17647059,22.5105189 18.8277727,22.5119048 18.8277727,22.5119048 C18.8235294,17.580791 14.8731007,13.5833333 10,13.5833333 Z M10,12.202381 C6.75126618,12.202381 4.11764706,9.53740923 4.11764706,6.25 C4.11764706,2.96259077 6.75126618,0.297619048 10,0.297619048 C13.2487338,0.297619048 15.8823529,2.96259077 15.8823529,6.25 C15.8823529,9.53740923 13.2487338,12.202381 10,12.202381 Z M10,11.0119048 C12.5989871,11.0119048 14.7058824,8.87992738 14.7058824,6.25 C14.7058824,3.62007262 12.5989871,1.48809524 10,1.48809524 C7.40101294,1.48809524 5.29411765,3.62007262 5.29411765,6.25 C5.29411765,8.87992738 7.40101294,11.0119048 10,11.0119048 Z"
}))));
function SvgProfileIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "24px",
    viewBox: "0 0 20 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun_profile_1594250") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconBlack);
export default __webpack_public_path__ + "static/media/profile-icon--black.1fceb223a3e2290beef74278f7c8fec6.svg";
export { ForwardRef as ReactComponent };